/** Sub-path the app is served under (`/find` on cmw.org.au), set at build time. Empty when served at the root. */
export const BASE_PATH = process.env.NEXT_PUBLIC_BASE_PATH ?? "";

/** Prefixes a root-relative path for URLs Next.js doesn't prefix itself: plain `src`/`href`, fetch, route handler redirects. */
export const withBasePath = (path: string): string => `${BASE_PATH}${path}`;
